<template>
  <div>
    <div class="collaborator-section d-md-flex flex-column flex-md-row">
      <director-block
        v-for="collaborator in collaborators"
        v-show="collapsed"
        :key="collaborator.id"
        :director="collaborator"
        :role="collaborator.role"
        :collapsed="collapsed"
        class="col-md-3"
        :style="{paddingLeft:'6px'}"
      />
    </div>
    <div
      v-show="!collapsed"
      class="collaborator-section flex-row"
      :style="{alignItems:'center'}"
      @click="clickArrow"
    >
      <span>
        <profile-picture-initial
          v-for="(profile,index) in initialProfiles"
          v-show="index<5"
          :key="index"
          :src="profile"
          :size="24"
          :style="{zIndex: initialProfiles.length-index, marginLeft: index===0 ? 0 : '-8px'}"
        />
      </span>
      <span class="minimize-names">
        {{ collaboratorNames }}
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import { Model } from '@viddsee/server-api-client';

import DirectorBlock from './DirectorBlock.ts.vue';
import i18n from '../Player/InPlayerOverlays/implementation/FilmReviewOverlays/localization.json';
import ProfilePictureInitial from '@/scripts/Components/Molecules/ProfilePictureInitial.vue';
import userResponseProcessor from '@/scripts/libs/login/userResponseProcessor';
import { MergeCollaborator } from './index.ts.vue';

export default Vue.extend({
  i18n,
  components: {
    DirectorBlock,
    ProfilePictureInitial,
  },
  props: {
    collaborators: {
      type: Array as PropType<MergeCollaborator[]>,
      required: true,
    },
    video: {
      type: Object as PropType<Model.Video.Info>,
      required: true,
    },
    collapsed: Boolean,
  },
  computed: {
    collaboratorNames(): string {
      let collaboratorNames='';
      const names= this.collaborators.map((collaborator) => collaborator.name);
      collaboratorNames=names.join(', ');
      return collaboratorNames;
    },
    initialProfiles(): Array<string> {
      const initialProfiles: Array<string>=[];
      this.collaborators.forEach(collaborator => {
        initialProfiles.push(userResponseProcessor.normalizeImage(72, collaborator.profileImageUrl, collaborator.name));
      });
      return initialProfiles;
    },

  },
  methods: {
    clickArrow(isCollapsed: boolean): boolean {
      this.$emit('clickArrow', isCollapsed);
      return isCollapsed;
    },
  },
});
</script>

<style lang="scss" scoped>
@import '~@/stylesheets/exports/_component-entry';
.collaborator-section {
  display: flex;
  position: relative;
  flex-wrap: wrap;
  max-width: 100%;
  align-items: flex-start;
  @media(min-width:768px) {
    display: none;
  }
}
.minimize-names {
  margin-left: 12px;
  max-width:50vw;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  @media(max-width: 768px) {
    max-width: 45vw;
  }
}
</style>
